export default "__VITE_ASSET__10CZM9Gk__"